module.exports = __webpack_public_path__ + "20250721160708/img/homework_icon.242ab86b.png";